import { useLocalization } from '@magicdoor/ui';
import { emptyPlaceholder } from '~/utils/constant';
export class Dict<T, Meta = Record<string, any>> {
  constructor(
    protected readonly dict: Array<{ label: string; value: T; meta?: Meta }>,
    public readonly options: { defaultMeta?: Meta; labelPlaceholder?: string } = {}
  ) {}

  getLabelByValue(value: T | undefined, raw: boolean = false): string {
    const option = this.dict.find((opt) => opt.value === value);
    const { t } = useLocalization();
    if (option) {
      return raw ? option.label : t(option.label);
    }
    return this.options.labelPlaceholder || emptyPlaceholder;
  }

  getMetaByValue(value: T | undefined): Meta | undefined {
    const option = this.dict.find((opt) => opt.value === value);
    return option?.meta || this.options.defaultMeta;
  }

  getOptions(raw: boolean = false): Array<{ label: string; value: T; meta?: Meta }> {
    const { t } = useLocalization();
    return this.dict.map((opt) => ({ label: raw ? opt.label : t(opt.label), value: opt.value, meta: opt.meta }));
  }
}
